export const variedades = [
  { id: 1, codigo: 'NAR-IMP', nombre: 'Naranja Imp' },
  { id: 2, codigo: 'VAL-LATE', nombre: 'Valencia Late' },
  { id: 3, codigo: 'NAV-IMP', nombre: 'Navel Importacion' },
  { id: 4, codigo: 'NOVA-I', nombre: 'Nova I.' },
  { id: 5, codigo: 'CLEM', nombre: 'Clemenules' },
  { id: 6, codigo: 'LANE-LATE', nombre: 'Lane-late' },
];

export const almacenes = [
  { id: 1, nombre: 'Betxi' },
  { id: 2, nombre: 'Alquerias' },
  { id: 3, nombre: 'Ulldecona' },
];

export const usuarios = [
  { id: 1, nombre: 'Administrador' },
  { id: 2, nombre: 'Encargado Betxi' },
  { id: 3, nombre: 'Encargado Alquerias' },
  { id: 4, nombre: 'Encargado Ulldecona' },
];

export const pesosPalot = ['183', '194'];
export const pesosCaja = ['18', '19', '20'];
export const pesoPalotMermaDefault = 183;

export const cajasPalet = [
  { id: 1, cajas: 30 },
  { id: 2, cajas: 36 },
  { id: 3, cajas: 42 },
];
